import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import InventoryTableTabs, { InventoryStatusTab } from "./InventoryTableTabs";
import type { TableViewId } from "./StockTransferenciasDetailTypes";
import type { TableColumn } from "react-data-table-component";

type StockTransferenciasDetailTableProps = {
  tabs: InventoryStatusTab[];
  activeTab: TableViewId;
  onTabChange: (next: TableViewId) => void;
  columns: TableColumn<any>[];
  data: any[];
  emptyMessage: string;
  renderActions?: (tabId: string) => React.ReactNode;
  isLoading?: boolean;
};

const StockTransferenciasDetailTable = ({
  tabs,
  activeTab,
  onTabChange,
  columns,
  data,
  emptyMessage,
  renderActions,
  isLoading = false,
}: StockTransferenciasDetailTableProps) => {
  if (isLoading) {
    return (
      <Col xs={12}>
        <Card className="border-0 shadow-sm">
          <CardBody>
            <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
              {Array.from({ length: 4 }).map((_, index) => (
                <div
                  key={`tab-skeleton-${index}`}
                  className="skeleton-pulse skeleton-line"
                  style={{ width: 120, height: 32, borderRadius: 999 }}
                />
              ))}
            </div>
            <div className="mb-3 d-flex justify-content-end gap-2 flex-wrap">
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={`action-skeleton-${index}`}
                  className="skeleton-pulse skeleton-line"
                  style={{ width: 150, height: 34, borderRadius: 12 }}
                />
              ))}
            </div>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    {Array.from({ length: 6 }).map((_, index) => (
                      <th key={`head-skeleton-${index}`}>
                        <div className="skeleton-pulse skeleton-line" style={{ width: "70%" }} />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 5 }).map((_, rowIndex) => (
                    <tr key={`row-skeleton-${rowIndex}`}>
                      {Array.from({ length: 6 }).map((_, colIndex) => (
                        <td key={`cell-skeleton-${rowIndex}-${colIndex}`}>
                          <div className="skeleton-pulse skeleton-line" style={{ width: "80%", height: 14 }} />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

  return (
    <Col xs={12}>
      <InventoryTableTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(tab) => onTabChange(tab as TableViewId)}
        columns={columns}
        data={data}
        emptyMessage={emptyMessage}
        searchPlaceholder="Buscar..."
        renderActions={renderActions}
      />
    </Col>
  );
};

export default StockTransferenciasDetailTable;
